
import './testPage.css'
import { useState } from 'react'
import image1 from '../../image/unYotoqxona/yt1.png'
import image2 from '../../image/unYotoqxona/yt2.png'
import image3 from '../../image/unYotoqxona/yt3.png'
import image4 from '../../image/unYotoqxona/yt4.png'
import image5 from '../../image/unYotoqxona/yt5.png'


export default function TTJ() {
    const [activeImage, setActiveImage] = useState(null)
    const images = [image1, image2, image3, image4, image5]

    const closeModal = () => setActiveImage(null)

    return (
        <div className="tp">
            <header className="tp_header">
                <h1>Urganch Ranch texnologiya universiteti talabalar turar joyi haqida maʼlumot</h1>
                <p className="tp_date">(25.08.2025 holatiga)</p>
            </header>

            <section className="tp_intro card">
                <p>
                    Urganch Ranch texnologiya universitetining yangi talabalar turar joyi 2025 yil mart oyida qurilib foydalanishga topshirilgan bo‘lib, Urganch shahar Xonqa ko‘chasi 26A-uy manzilida joylashgan.
                </p>
            </section>

            <section className="tp_stats">
                <div className="stat card">
                    <h3>Qavatlar</h3>
                    <p>5 qavat</p>
                </div>
                <div className="stat card">
                    <h3>Umumiy sig‘im</h3>
                    <p>528 o‘rin</p>
                </div>
                <div className="stat card">
                    <h3>Manzil</h3>
                    <p>Xonqa ko‘chasi 26A, Urganch</p>
                </div>
            </section>

            <section className="tp_features card">
                <h2>Qulayliklar</h2>
                <ul>
                    <li>Har bir qavatda oshxona, hojatxona, yuvinish va kir yuvish xonalari mavjud.</li>
                    <li>Mini-futbol, shashka, shaxmat, basketbol, voleybol, fitnes bilan shug‘ullanish sharoitlari yaratilgan.</li>
                </ul>
            </section>

            <section className="tp_plan card">
                <h2>Jihozlash va rejalashtirilgan ishlar</h2>
                <p>
                    Hozirda jihozlash ishlari olib borilmoqda. Talabalarning bo‘sh vaqtlarini mazmunli o‘tkazish maqsadida har bir qavatning maʼnaviyat burchaklarida kitob javonlari, televizor, yumshoq mebellar joylashtiriladi.
                </p>
                <p>
                    Kompyuter sinfi, tikuvchilik, to‘quvchilik, rassomchilik to‘garaklari faoliyati yo‘lga qo‘yilishi rejalashtirilgan.
                </p>
            </section>

            <section className="tp_demand card">
                <h2>Talab va qamrov</h2>
                <p>
                    O‘tgan o‘quv yilida 250 nafar talabadan talabalar turar joyiga ehtiyoj borligi aniqlangan. Joriy o‘quv yilida ehtiyoj 2 barobarga oshishi kutilmoqda.
                </p>
                <p>
                    Yangi talabalar turar joyining ishga tushishi orqali TTTJga ehtiyoj 100 foizga qondiriladi.
                </p>
            </section>

            <section className="tp_gallery">
                <div className="gallery_header">
                    <h2>Foto galereya</h2>
                    <p>Rasm ustiga bosing — kattalashtiriladi</p>
                </div>
                <div className="grid">
                    {images.map((src, idx) => (
                        <button
                            key={idx}
                            className="thumb"
                            onClick={() => setActiveImage(src)}
                            aria-label={`Rasm ${idx + 1} ni kattalashtirish`}
                        >
                            <img src={src} alt={`Yotoqxona rasm ${idx + 1}`} />
                        </button>
                    ))}
                </div>
            </section>

            {activeImage && (
                <div className="tp_modal" role="dialog" aria-modal="true" onClick={closeModal}>
                    <div className="tp_modal_inner" onClick={(e) => e.stopPropagation()}>
                        <button className="tp_modal_close" onClick={closeModal} aria-label="Yopish">×</button>
                        <img src={activeImage} alt="Kattalashtirilgan rasm" />
                    </div>
                </div>
            )}

            <footer className="tp_footer">
                <p>Yoshlar masalalari va maʼnaviy-maʼrifiy ishlar bo‘yicha prorektor</p>
                <p className="tp_sign">A.Xudaybergenov</p>
            </footer>
        </div>
    )
}